<template>
  <guest-layout>
    <template #header>
      <font-awesome-icon icon="fas fa-unlock-keyhole" />
      Silakan atur ulang password Anda
    </template>

    <Head title="Reset Password" />

    <div class="container p-6 mx-auto my-6 max-w-8xl">
      <div class="flex flex-wrap justify-between bg-white rounded-lg shadow-xl md:flex">
        <div class="w-full md:w-6/12 lg:w-5/12">
          <form class="px-10 py-4 overflow-hidden" @submit.prevent="submit">
            <h1 class="text-2xl font-bold text-center">Ganti Password</h1>
            <div class="w-24 mx-auto mt-6 border-b-2" />

            <input v-model="form.token" type="hidden" />
            <input v-model="form.email" type="hidden" />
            <text-input
              id="password" v-model="form.password" :error="form.errors.password" class="mt-10"
              label="Password Baru" type="password" autocomplete="new-password"
            />
            <text-input
              id="password_confirmation" v-model="form.password_confirmation"
              :error="form.errors.password_confirmation" class="mt-6" label="Konfirmasi Password" type="password"
              autocomplete="new-password"
            />

            <loading-button :loading="form.processing" class="mt-6 btn-green" type="submit">
              <font-awesome-icon icon="fas fa-check" />
              &nbsp;Reset Password
            </loading-button>
          </form>
        </div>
        <div class="relative hidden w-0 rounded-tr-lg rounded-br-lg md:w-6/12 lg:w-7/12 md:flex md:flex-col">
          <img src="/images/background.png" alt="Background" class="flex-1 object-cover" />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import GuestLayout from '@/Layouts/GuestLayout.vue'

export default {
  components: {
    Head,
    TextInput,
    LoadingButton,
    GuestLayout,
  },
  props: {
    token: String,
    email: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        token: this.token || '',
        email: this.email || '',
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/reset-password')
    },
  },
}
</script>
